<template>
  <div class="chatusers mb-2">
    <span class="users-title p-2">
      <i class="fa fa-users fa-lg fa-fw"></i>
      Utilisateurs connectés ({{ connectedUsers.length }})
    </span>
    <br>
    <ul class="m-2">
      <li
        v-for="(user, index) in connectedUsers"
        :key="index"
        :class="isMyHandle(user) ? 'my-user' : 'other-user'"
      >{{ user }}</li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ChatUsers",
  mounted: function() {
    this.$socket.emit("connected", this.loggedUser.username);
  },
  computed: {
    ...mapState({
      loggedUser: state => state.account.user,
      handle: state => state.chat.handle
    })
  },
  methods: {
    isMyHandle(handle) {
      return handle === this.handle;
    }
  },
  data: function() {
    return {
      connectedUsers: []
    };
  },
  sockets: {
    connectedUsers: function(connectedUsers) {
      this.connectedUsers = [...new Set(connectedUsers)];
    }
  }
};
</script>

<style>
.chatusers {
  height: 50vh;
  background-color: #e6ffe6;
  border: 1px solid #32cd32;
  border-radius: 0.25rem;
}
.users-title {
  color: #2aab2a;
  font-family: "Amaranth", sans-serif;
  font-size: 1.25rem;
}
.users-title .fa-users {
  font-size: 1.25rem;
  vertical-align: middle;
}
.chatusers ul li {
  list-style: none;
  text-align: left;
}
.my-user {
  color: #f00;
  font-size: 1rem;
  font-weight: bold;
}
.other-user {
  color: #2aab2a;
  font-size: 1rem;
  font-weight: bold;
}
</style>